module.exports = __webpack_public_path__ + "img/intro-project-1.jpg?abcea4c84fba2be1b46eb37cebe3613a";